import React, { useMemo, useState } from "react";
import activityTypes from "../data/activityTypes.json";
import SelectField from "../../components/SelectField";
import VStack from "../../ui_atoms/VStack";
import Text from "../../components/Text";
import type { Meta, StoryObj } from "@storybook/react";
import { SelectItemType } from "../../components/select/SelectChooser";
import Button from "../../components/Button";
import { ScrollView } from "react-native";

function StoryComponent({ disabled }: { disabled: boolean }) {
    const [selectValue1, setSelectValue1] = useState<SelectItemType<string>>();
    const [selectValue2, setSelectValue2] = useState<SelectItemType<string>>();
    const [selectValue3, setSelectValue3] = useState<SelectItemType<string>>();
    const [selectValue4, setSelectValue4] = useState<SelectItemType<string>>();
    const [selectValue5, setSelectValue5] = useState<SelectItemType<string>>();
    const [selectValue6, setSelectValue6] = useState<SelectItemType<string>>();
    const [selectValue7, setSelectValue7] = useState<SelectItemType<string>>();

    const largeData = useMemo(() => {
        return Array.from({ length: 30 }, (_, i) => ({
            label: `Item ${i}`,
            value: `item-${i}`,
        }));
    }, []);

    const normalizedItems = useMemo(() => {
        return (activityTypes as SelectItemType<string>[]).map((at) => {
            return {
                label: at.label,
                value: at.value,
                _normalizedSearch: at.label
                    .normalize("NFD")
                    .replace(/\p{Diacritic}/gu, "")
                    .toLowerCase(),
            };
        });
    }, []);

    return (
        <ScrollView>
            <VStack gap="1" style={{ padding: 10, alignSelf: "stretch" }}>
                <SelectField<string>
                    style={{ alignSelf: "stretch" }}
                    value={selectValue1?.value}
                    left="training"
                    data={async (filter) => {
                        if (filter === "") {
                            return Promise.resolve(activityTypes);
                        }
                        const normalizedFilter = filter
                            .toLowerCase()
                            .normalize("NFD")
                            .replace(/\p{Diacritic}/gu, "");
                        const filteredActivities = normalizedItems.filter((at) => {
                            return at._normalizedSearch.indexOf(normalizedFilter) !== -1;
                        });
                        return Promise.resolve(filteredActivities);
                    }}
                    label="Activité"
                    onSelect={setSelectValue1}
                    emptyText="Type something to find something"
                    emptyResult={<Text style={{ paddingHorizontal: 10 }}>No match!</Text>}
                    searchPlaceholder="Choose an activity type"
                    resultTitle="Résultat"
                    tipText="Si votre CCT ne fait pas partie de la liste ci-dessous, vous pouvez choisir la CCT de “Location de services”."
                    disabled={disabled}
                />
                <SelectField
                    style={{ alignSelf: "stretch" }}
                    value={selectValue2?.value}
                    data={async (filter) => {
                        if (filter === "") {
                            return Promise.resolve(activityTypes);
                        }
                        const normalizedFilter = filter
                            .toLowerCase()
                            .normalize("NFD")
                            .replace(/\p{Diacritic}/gu, "");
                        const filteredActivities = normalizedItems.filter((at) => {
                            return at._normalizedSearch.indexOf(normalizedFilter) !== -1;
                        });
                        return Promise.resolve(filteredActivities);
                    }}
                    label="Profession"
                    onSelect={setSelectValue2}
                    emptyText="Type something to find something"
                    emptyResult={<Text style={{ paddingHorizontal: 10 }}>No match!</Text>}
                    searchPlaceholder="Choose an activity type"
                    resultTitle="Résultat"
                    disabled={disabled}
                />
                <SelectField
                    style={{ alignSelf: "stretch" }}
                    value={selectValue3?.value}
                    left="holiday"
                    data={[
                        {
                            label: "Jimi Hendrix",
                            value: "jh",
                        },
                        {
                            label: "Michel Jackson",
                            value: "mj",
                        },
                        {
                            label: "Bob Dylan qui a un nom super long pour tester les affichages sur deux lignes et encore plus long",
                            value: "bd",
                        },
                        {
                            label: "Kurt Cobain",
                            value: "kc",
                            icon: "mission",
                        },
                        {
                            label: "Stevie Wonder",
                            value: "sw",
                        },
                        {
                            label: "Marvin Gaye",
                            value: "mg",
                        },
                        {
                            label: "Eric Clapton",
                            value: "ec",
                        },
                    ]}
                    label="Musician"
                    searchPlaceholder="Select your musician"
                    onSelect={setSelectValue3}
                    numberOfLines={2}
                    disabled={disabled}
                />
                <SelectField
                    style={{ alignSelf: "stretch" }}
                    value={selectValue4?.value}
                    halfScreen
                    left="work"
                    data={[
                        {
                            label: "Slash",
                            value: "sl",
                        },
                        {
                            label: "Mark Knopfler",
                            value: "mk",
                        },
                        {
                            label: "Carlos Santana",
                            value: "cs",
                        },
                        {
                            label: "Eddie Van Halen",
                            value: "evh",
                        },
                        {
                            label: "Chuck Berry",
                            value: "cb",
                        },
                        {
                            label: "John Petrucci",
                            value: "jp",
                        },
                        {
                            label: "Brian May",
                            value: "bm",
                        },
                    ]}
                    label="Guitarist"
                    searchPlaceholder="Select your guitarist"
                    onSelect={setSelectValue4}
                    disabled={disabled}
                    bottomComponent={
                        <VStack>
                            <Button label="Annitional component" />
                        </VStack>
                    }
                />
                <SelectField
                    style={{ alignSelf: "stretch" }}
                    value={selectValue5?.value}
                    halfScreen
                    data={[
                        {
                            label: "PRS - Custom 24",
                            value: "prs",
                        },
                        {
                            label: "Les Paul",
                            value: "lp",
                        },
                        {
                            label: "EPS - Horizon II",
                            value: "eps",
                        },
                        {
                            label: "Stratocaster",
                            value: "st",
                        },
                        {
                            label: "Telecaster",
                            value: "tely",
                        },
                        {
                            label: "Music man - John Petrucci",
                            value: "jp",
                        },
                        {
                            label: "Ibanez - RG5120",
                            value: "ib",
                        },
                    ]}
                    label="Guitar"
                    searchPlaceholder="Select your guitar"
                    onSelect={setSelectValue5}
                    disabled={disabled}
                />

                <SelectField
                    style={{ alignSelf: "stretch" }}
                    value={selectValue6?.value}
                    data={[
                        {
                            label: "The Shape of Punk to Come: A Chimerical Bombination in 12 Bursts - Refused (1998) - Suède",
                            value: "001",
                        },
                        {
                            label: "The Rise and Fall of Ziggy Stardust and the Spiders from Mars - David Bowie (1971) - Royaume-Uni",
                            value: "002",
                        },
                        {
                            label: "Lift Your Skinny Fists Like Antennas to Heaven - Godspeed You! Black Emperor (2000) - Canada - Lift Your Skinny Fists Like Antennas to Heaven - Godspeed You! Black Emperor (2000) - Canada ",
                            value: "003",
                        },
                    ]}
                    label="Album name"
                    searchPlaceholder="Select your album name"
                    onSelect={setSelectValue6}
                    halfScreen
                    disabled={disabled}
                />

                <SelectField
                    style={{ alignSelf: "stretch" }}
                    value={selectValue7?.value}
                    data={largeData}
                    label="Large list"
                    searchPlaceholder="Select a sample value"
                    onSelect={setSelectValue7}
                    halfScreen
                    disabled={disabled}
                />

                <SelectField
                    style={{ alignSelf: "stretch" }}
                    data={[{ label: "Item 1", value: "item1" }]}
                    label="1 item list"
                    searchPlaceholder="Select a sample value"
                    onSelect={setSelectValue7}
                    halfScreen
                    disabled={disabled}
                />
                <SelectField
                    style={{ alignSelf: "stretch" }}
                    data={[{ label: "Item 1", value: "item1" }]}
                    placeholder="Simple placeholder"
                    onSelect={setSelectValue7}
                    value={selectValue7?.value}
                    halfScreen
                    disabled={disabled}
                />
                <SelectField
                    style={{ alignSelf: "stretch" }}
                    data={[{ label: "Item 1", value: "item1" }]}
                    placeholder="Simple placeholder with value"
                    onSelect={setSelectValue7}
                    value={"1"}
                    halfScreen
                    disabled={disabled}
                />
            </VStack>
        </ScrollView>
    );
}

const meta = {
    title: "Fields/Select",
    component: StoryComponent,
    argTypes: {
        disabled: {
            control: {
                type: "boolean",
            },
        },
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        disabled: false,
    },
};

export const Disabled: Story = {
    args: {
        disabled: true,
    },
};
